import React from "react";
import SideAdsContainer from "components/SideAdsContainer";

const CovidReadMore = (props) => {
  return (
    <div className="covid-readmore-page">
      <div className="covid-readmore-container content-side-padding">
        <div className="response-header">COVID-19 RESPONSE</div>
        <div className="free-boost-text">FREE BOOST FOR ALL USERS</div>
        <div className="main-content">
          <div>
            Shinggo here - one of the site's co-founders. On behalf of the U.GG team, Alan and I hope you are staying safe during
            the pandemic. We’re sure plenty of news has already come your way and that we aren’t the first company to reach out.
            Still, we want to do what we can to help make your time at home more enjoyable.
          </div>
          <div>
            It’s not much, but we’ve made BOOST, our subscription service, free to all for the next 60 days. No payment
            information is required - simply create or login to your free account to get access to BOOST content, such as Combo
            Database, Customized Profiles, S9 Year in Review, and more. Existing and new BOOST users will not be billed for the
            next 60 days. We are looking into other ways we can support the community and will extend the duration as necessary.
          </div>
          <div>
            Like a lot of you, Alan and I fall into an age group which puts us at lower risk. Some of us may have COVID-19 and
            show zero symptoms. Still, we hope you will take extra steps to flatten the curve - remember to do it, if not for
            yourself, but for your parents, the at-risk and older people around you, and the medical staff and healthcare
            employees working hard to contain this risk. Neither Alan nor I are experts by any means - we’ve attached a few
            resources we found helpful.
          </div>
          <div className="ital">
            Stay safe everyone,
            <br />
            Shinggo Lu
            <br />
            Co-Founder and CEO
          </div>
        </div>
        <div className="resources">Resources</div>
        <div className="resources-list">
          <ul>
            <li>
              <a href="https://www.youtube.com/watch?v=BtN-goy9VOY">
                VIDEO: The Coronavirus Explained & What You Should DO (Kurzgesagt)
              </a>
            </li>
            <li>
              <a href="https://www.cdc.gov/coronavirus/2019-ncov/prepare/prevention.html">
                STEPS: Preventative Measures (CDC, Centers for Desease Control and Prevention)
              </a>
            </li>
            <li>
              <a href="https://www.cdc.gov/coronavirus/2019-ncov/if-you-are-sick/index.html">
                STEPS: If you Think You Are Sick (CDC)
              </a>
            </li>
            <li>
              <a href="https://www.cdc.gov/coronavirus/2019-ncov/specific-groups/high-risk-complications.html">
                STEPS: Are You At Higher Risk for Severe Illness? (CDC)
              </a>
            </li>
            <li>
              <a href="https://ourworldindata.org/coronavirus#flattening-the-curve">
                DATA: Statistics and Research - Flattening the Curve (Our World In Data)
              </a>
            </li>
            <li>
              <a href="https://covid19responsefund.org/">DONATE: WHO COVID-19 Response Fund (WHO, World Health Organization)</a>
            </li>
          </ul>
        </div>
        <div className="effect-header">
          For All User Types:
          <br />
          How These Changes Affect Your Billing Cycle
        </div>
        <div className="plans-container">
          <div>
            <span className="number">1.</span>
            <span className="bold-plan-text">Monthly Plan BOOST Users: </span>As of 3/30, BOOST Users on monthly billing will have
            a 100% discount coupon automatically applied to their next two billing cycles.
          </div>
          <div>
            <span className="number">2.</span>
            <span className="bold-plan-text">Biannual Plan BOOST Users: </span>BOOST Users on biannual billing will have 60 days
            added to their next bill date. Ex: Users currently with a 6/14/20 bill date will receive an update extending to their
            renewal date to 8/13/20.
          </div>
          <div>
            <span className="number">3.</span>
            <span className="bold-plan-text">Annual Plan BOOST Users: </span>BOOST Users on annual billing will have 60 days added
            to their next bill date. Ex: users currently with a 1/14/21 bill date will receive an update extending to their
            renewal date to 3/15/21.
          </div>
        </div>
      </div>
      <SideAdsContainer />
    </div>
  );
};

export default CovidReadMore;
